import AppStoreIcon from 'app/assets/icons/profile/auctions/app-store.svg'
import GooglePlayIcon from 'app/assets/icons/profile/auctions/google-play.svg'
import Stack from 'app/components/base/Stack'
import { downloadAppUrls } from 'app/utils/constants/options.constants'

import ExternalLinkButton from '~/components/buttons/ExternalLinkButton'

export const DownloadAppSection = () => {
  return (
    <Stack
      direction="row"
      spacing={1}
      sx={{ mt: 4, alignSelf: { xs: 'center', md: 'flex-start' } }}
    >
      <ExternalLinkButton link={downloadAppUrls.apple} sx={{ width: 140 }}>
        <AppStoreIcon />
      </ExternalLinkButton>

      <ExternalLinkButton link={downloadAppUrls.google} sx={{ width: 140 }}>
        <GooglePlayIcon />
      </ExternalLinkButton>
    </Stack>
  )
}
